/* global G */
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import { settings } from 'app/_shared/session'
import sequenceComponentState from 'lib/sequence/component/state'

const {
  set: classes,
} = sequenceComponentState('classes')

/**
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const text = module => component => async (...args) => {
  const ns = module[G.MODEL][G.STATE][G.REF]
  const { content } = find(component)

  const { staticActions } = settings
  const staticAction = staticActions?.find(item => item.options.name === ns)
  const { style } = staticAction?.options || {}

  style && classes(component, style)

  await module[G.ADAPTER][G.INTL].add([ns])

  const value = module[G.ADAPTER][G.INTL].markdown('text', {
    ns,
    _key: 'text',
    joinArrays: '\n',
    md: true,
  })

  set(content, value)

  return args
}

export default text
